import React, { Fragment, useState, useMemo } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import ContactList from './contacts/contact-list'
import ContactAction from './contacts/contact-action'

const VenueContacts = ({ rootClassName, venueId, handleSetSuccess, setSelectedSection }) => {
  const [action, setAction] = useState('view')
  const [contact, setContact] = useState(null)
  const renderContactByAction = useMemo(() => {
    if (action === 'view')
      return (
        <ContactList
          handleSetSuccess={handleSetSuccess}
          venueId={venueId}
          setContact={setContact}
          setAction={setAction}
        />
      )
    return (
      <ContactAction
        contact={contact}
        action={action}
        handleSetSuccess={handleSetSuccess}
        venueId={venueId}
        setSelectedSection={setSelectedSection}
        setAction={setAction}
      />
    )
  })

  const renderDetailsSection = () => {
    return <Fragment>{renderContactByAction}</Fragment>
  }

  return <div className={rootClassName}>{renderDetailsSection()}</div>
}

VenueContacts.defaultProps = {
  rootClassName: '',
}

VenueContacts.propTypes = {
  rootClassName: PropTypes.string,
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  venueId: PropTypes.number,
  handleSetSuccess: PropTypes.func,
  setSelectedSection: PropTypes.func,
}

const mapStateToProps = ({ venue }) => ({
  venueId: venue.details.id,
})

export default connect(mapStateToProps)(VenueContacts)
